import { ProductDetailActionsRenderTargetComponent } from './product-details-actions.render-target.component';
import { ProductDetailBadgesRenderTargetComponent } from './product-details-badges.render-target.component';
import { ProductDetailDefaultRenderTargetComponent } from './product-details-default.render-target.component';
import { ProductDetailExtraActionsRenderTargetComponent } from './product-details-extra-actions.render-target.component';
import { ProductDetailFooterRenderTargetComponent } from './product-details-footer.render-target.component';
import { ProductDetailHeaderRenderTargetComponent } from './product-details-header.render-target.component';
import { ProductDetailImagesRenderTargetComponent } from './product-details-images.render-target.component';
import { ProductDetailImportantInfoRenderTargetComponent } from './product-details-important-info.render-target.component';
import { ProductDetailInfoRenderTargetComponent } from './tmp/product-details-info.render-target.component';
import { ProductDetailLongDescriptionRenderTargetComponent } from '../product-details-long-description.render-target.component';
import { ProductDetailPriceRenderTargetComponent } from './tmp/product-details-price.render-target.component';
import { ProductDetailStockRenderTargetComponent } from './tmp/product-details-stock.render-target.component';
import { ProductDetailTitleRenderTargetComponent } from './product-details-title.render-target.component';
import { ProductDetailToolsRenderTargetComponent } from './tmp/product-details-tools.render-target.component';
import { ProductDetailVendorRenderTargetComponent } from './product-details-vendor.render-target.component';

export const RenderTargetComponents = [
  ProductDetailImportantInfoRenderTargetComponent,
  ProductDetailInfoRenderTargetComponent,
  ProductDetailHeaderRenderTargetComponent,
  ProductDetailImagesRenderTargetComponent,
  ProductDetailFooterRenderTargetComponent,
  ProductDetailLongDescriptionRenderTargetComponent,
  ProductDetailToolsRenderTargetComponent,
  ProductDetailBadgesRenderTargetComponent,
  ProductDetailDefaultRenderTargetComponent,
  ProductDetailActionsRenderTargetComponent,
  ProductDetailPriceRenderTargetComponent,
  ProductDetailExtraActionsRenderTargetComponent,
  ProductDetailTitleRenderTargetComponent,
  ProductDetailStockRenderTargetComponent,
  ProductDetailVendorRenderTargetComponent,
];
